import IconAep from "@/features/my-files/assets/file-icons/icon-aep.svg?react";
import IconAi from "@/features/my-files/assets/file-icons/icon-ai.svg?react";
import IconAvi from "@/features/my-files/assets/file-icons/icon-avi.svg?react";
import IconCsv from "@/features/my-files/assets/file-icons/icon-csv.svg?react";
import IconDoc from "@/features/my-files/assets/file-icons/icon-doc.svg?react";
import IconDocx from "@/features/my-files/assets/file-icons/icon-docx.svg?react";
import IconEps from "@/features/my-files/assets/file-icons/icon-eps.svg?react";
import IconFallback from "@/features/my-files/assets/file-icons/icon-fallback.svg?react";
import IconFig from "@/features/my-files/assets/file-icons/icon-fig.svg?react";
import IconGif from "@/features/my-files/assets/file-icons/icon-gif.svg?react";
import IconImg from "@/features/my-files/assets/file-icons/icon-img.svg?react";
import IconIndd from "@/features/my-files/assets/file-icons/icon-indd.svg?react";
import IconJpeg from "@/features/my-files/assets/file-icons/icon-jpeg.svg?react";
import IconJpg from "@/features/my-files/assets/file-icons/icon-jpg.svg?react";
import IconMkv from "@/features/my-files/assets/file-icons/icon-mkv.svg?react";
import IconMov from "@/features/my-files/assets/file-icons/icon-mov.svg?react";
import IconMp3 from "@/features/my-files/assets/file-icons/icon-mp3.svg?react";
import IconMp4 from "@/features/my-files/assets/file-icons/icon-mp4.svg?react";
import IconMpeg from "@/features/my-files/assets/file-icons/icon-mpeg.svg?react";
import IconPdf from "@/features/my-files/assets/file-icons/icon-pdf.svg?react";
import IconPng from "@/features/my-files/assets/file-icons/icon-png.svg?react";
import IconPpt from "@/features/my-files/assets/file-icons/icon-ppt.svg?react";
import IconPptx from "@/features/my-files/assets/file-icons/icon-pptx.svg?react";
import IconPsd from "@/features/my-files/assets/file-icons/icon-psd.svg?react";
import IconSvg from "@/features/my-files/assets/file-icons/icon-svg.svg?react";
import IconTiff from "@/features/my-files/assets/file-icons/icon-tiff.svg?react";
import IconTxt from "@/features/my-files/assets/file-icons/icon-txt.svg?react";
import IconWav from "@/features/my-files/assets/file-icons/icon-wav.svg?react";
import IconWebp from "@/features/my-files/assets/file-icons/icon-webp.svg?react";
import IconXls from "@/features/my-files/assets/file-icons/icon-xls.svg?react";
import IconXlsx from "@/features/my-files/assets/file-icons/icon-xlsx.svg?react";

// File icons mapping
export const FILE_ICONS = {
  aep: IconAep,
  ai: IconAi,
  avi: IconAvi,
  csv: IconCsv,
  doc: IconDoc,
  docx: IconDocx,
  eps: IconEps,
  fallback: IconFallback,
  fig: IconFig,
  gif: IconGif,
  img: IconImg,
  indd: IconIndd,
  jpeg: IconJpeg,
  jpg: IconJpg,
  mkv: IconMkv,
  mov: IconMov,
  mp3: IconMp3,
  mp4: IconMp4,
  mpeg: IconMpeg,
  pdf: IconPdf,
  png: IconPng,
  ppt: IconPpt,
  pptx: IconPptx,
  psb: IconPsd,
  psd: IconPsd,
  svg: IconSvg,
  tiff: IconTiff,
  txt: IconTxt,
  wav: IconWav,
  webp: IconWebp,
  xls: IconXls,
  xlsx: IconXlsx,
} as const;
